import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4970f751"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-background w-screen h-screen" }
const _hoisted_2 = { class: "flex flex-col justify-between" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "pageHeader flex justify-between",
  style: {"margin-top":"5px"}
}, "Anmerkungen", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "trenner-m" }, null, -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "title-container" }
const _hoisted_8 = {
  key: 0,
  class: "fragenBlock"
}
const _hoisted_9 = {
  class: "smallHeader",
  "data-cy": "note-title"
}
const _hoisted_10 = {
  key: 0,
  class: "textBlock",
  "data-cy": "note-description"
}
const _hoisted_11 = {
  key: 1,
  class: "textBlock mt-2"
}
const _hoisted_12 = { class: "mt-5 flex" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-2 mr-2 mt-3" }, "Fotos:", -1))
const _hoisted_14 = {
  key: 0,
  class: "mt-0",
  "data-cy": "pdf-note-photos"
}
const _hoisted_15 = {
  key: 1,
  class: "mt-3",
  "data-cy": "pdf-note-photos"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "trenner" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")!
  const _component_PdfImageRow = _resolveComponent("PdfImageRow")!
  const _component_page_bottom = _resolveComponent("page-bottom")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.splitIntoChunks(_ctx.hinweise), (hinweisblock, index) => {
    return (_openBlock(), _createBlock(_component_pdf_a4_page, {
      "no-margin": "",
      "pdf-key": _ctx.lang,
      class: "pdf-content",
      key: index
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_page_header, {
            ba: _ctx.ba,
            immobilie: _ctx.immobilie,
            Title: 'Hinweise'
          }, null, 8, ["ba", "immobilie"]),
          _createElementVNode("div", _hoisted_2, [
            (index === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass([index === 0  ? 'content' : 'content-long'])
            }, [
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hinweisblock, (hinweis, index2) => {
                  return (_openBlock(), _createElementBlock("div", { key: index2 }, [
                    (hinweis != null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(hinweis.frages?.[0].eingabeText), 1),
                          (hinweis.frages?.[2].eingabeText !== '')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(hinweis.frages?.[2].eingabeText), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString("Keine Beschreibung vorhanden"))),
                          _createElementVNode("div", _hoisted_12, [
                            _hoisted_13,
                            (hinweis.frages?.[1].eingabeMedien != null)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _createVNode(_component_PdfImageRow, {
                                    imageObjects: _ctx.getImageObjects(hinweis, 1)
                                  }, null, 8, ["imageObjects"])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_15, " Keine Fotos "))
                          ]),
                          _hoisted_16
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ], 2)
          ]),
          _createVNode(_component_page_bottom)
        ])
      ]),
      _: 2
    }, 1032, ["pdf-key"]))
  }), 128))
}